import { FAST_SERVER_URL } from "../../constants";
import { apiSlice } from "../api-slice";
import { AccessUser } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAccessUsers: build.query<AccessUser[], { accountId: number }>({
      query: ({ accountId }) => ({
        method: "GET",
        url: `${FAST_SERVER_URL}accountusers?accountId=${accountId}&includeExpired=false&product=FASTSCOUT2&scope=view_account_users`,
      }),
    }),
  }),
});

export const { useGetAccessUsersQuery, useLazyGetAccessUsersQuery } = extendedApiSlice;
